<template>
  <div class="component-upload-image">
    <el-upload
      multiple
      :disabled="disabled"
      :action="ossUploadUrl"
      list-type="picture-card"
      :on-success="handleUploadSuccess"
      :before-upload="handleBeforeUpload"
      :data="uploadData"
      :limit="limit"
      :on-error="handleUploadError"
      :on-exceed="handleExceed"
      ref="imageUpload"
      :on-remove="handleDelete"
      :show-file-list="true"
      :file-list="fileList"
      :on-preview="handlePictureCardPreview"
      :class="{hide: this.fileList.length >= this.limit}"
    >
      <i class="el-icon-plus"></i>
    </el-upload>

    <!-- 上传提示 -->
    <div class="el-upload__tip" slot="tip" v-if="isShowTip && !disabled">
      请上传
      <template v-if="fileSize"> 大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b> </template>
      <template v-if="fileType"> 格式为 <b style="color: #f56c6c">{{ fileType.join("/") }}</b> </template>
      的文件
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      title="预览"
      width="800"
      append-to-body
    >
      <img
        :src="dialogImageUrl"
        style="display: block; max-width: 100%; margin: 0 auto"
      />
    </el-dialog>
  </div>
</template>

<script>
import { isExternal } from "@/utils/validate"
import Sortable from 'sortablejs'
import OSS from 'ali-oss';  // 引入阿里云 OSS SDK

export default {
  props: {
    value: [String, Object, Array],
    action: {
      type: String,
      default: "/common/upload"
    },
    data: {
      type: Object
    },
    limit: {
      type: Number,
      default: 5
    },
    fileSize: {
      type: Number,
      default: 5
    },
    fileType: {
      type: Array,
      default: () => ["png", "jpg", "jpeg"]
    },
    isShowTip: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    drag: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      uploadList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      baseUrl: process.env.VUE_APP_BASE_API,
      fileList: [],
      ossClient: null,
      ossUploadUrl: '',  // OSS的上传URL
      uploadData: {
        // 这里可以添加其他上传需要的参数
      }
    }
  },
  mounted() {
    this.initOSSClient(); // 初始化OSS客户端
    if (this.drag && !this.disabled) {
      this.$nextTick(() => {
        const element = this.$refs.imageUpload?.$el?.querySelector('.el-upload-list')
        Sortable.create(element, {
          onEnd: (evt) => {
            const movedItem = this.fileList.splice(evt.oldIndex, 1)[0]
            this.fileList.splice(evt.newIndex, 0, movedItem)
            this.$emit("input", this.listToString(this.fileList))
          }
        })
      })
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          const list = Array.isArray(val) ? val : this.value.split(',')
          this.fileList = list.map(item => {
            if (typeof item === "string") {
              return { name: item, url: item }
            }
            return item
          })
        } else {
          this.fileList = []
          return []
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 初始化 OSS 客户端
    initOSSClient() {
      this.ossClient = new OSS({
        region: 'oss-cn-beijing', // 阿里云 OSS 区域
        accessKeyId: 'LTAI5tCQw7jqnWcztDtbs163',
        accessKeySecret: 'mh5YZsOgnEp5mvlJeJrVKM7ivihdo2',
        bucket: 'trainingts'
      });
      this.ossUploadUrl = `https://trainingts.oss-cn-beijing.aliyuncs.com/`;  // OSS 的基本上传 URL
    },
    // 处理上传前操作
    handleBeforeUpload(file) {
      // 校验文件类型和大小等逻辑
      if (!this.validateFile(file)) {
        return false;
      }
      this.$modal.loading("正在上传图片，请稍候...");
    },
    // 校验文件格式和大小
    validateFile(file) {
      let isImg = this.fileType.length ? this.fileType.includes(file.type.split('/')[1]) : true;
      if (!isImg) {
        this.$modal.msgError(`文件格式不正确，请上传 ${this.fileType.join("/")} 图片格式文件!`);
        return false;
      }
      if (file.size / 1024 / 1024 > this.fileSize) {
        this.$modal.msgError(`上传图片大小不能超过 ${this.fileSize} MB!`);
        return false;
      }
      return true;
    },
    // 文件个数超出
    handleExceed() {
      this.$modal.msgError(`上传文件数量不能超过 ${this.limit} 个!`);
    },
    // 上传成功回调
    async handleUploadSuccess(res, file) {
      try {
        const result = await this.ossClient.put(file.name, file);  // 直接上传文件
        this.uploadList.push({ name: result.name, url: result.url });
        this.fileList.push({ name: result.name, url: result.url });  // 更新 fileList 
        this.$emit("input", this.listToString(this.fileList));
      } catch (error) {
        this.$modal.msgError("上传失败: " + error);
      }
    },
    // 删除图片
    handleDelete(file) {
      const findex = this.fileList.map(f => f.name).indexOf(file.name);
      if (findex > -1) {
        this.fileList.splice(findex, 1);
        this.$emit("input", this.listToString(this.fileList));
      }
    },
    // 上传失败处理
    handleUploadError() {
      this.$modal.msgError("上传图片失败，请重试");
    },
    // 预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 对象转成指定字符串分隔
    listToString(list, separator = ",") {
      return list.map(item => item.url).join(separator);
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep.hide .el-upload--picture-card {
  display: none;
}

::v-deep .el-upload-list--picture-card.is-disabled + .el-upload--picture-card {
  display: none !important;
}

::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}

::v-deep .el-list-enter, .el-list-leave-active {
  opacity: 0;
  transform: translateY(0);
}
</style>